import React, { useEffect, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { ScrollView, Text, View } from "react-native";
import { getLoginData } from "../../../utility/AppStoreData";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { CommonButton } from "../../../common/CommonButton";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import HomeCards from "../../../Components/home-common-components/HomeCards";
import Separator from "../../../Components/Separator";
import GiftTable from "../../../Components/search-common-components/GiftTable";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import CreateEventModal from "../Event/CreateEventModal";
import EventTypeScreen from "../Event/EventTypeScreen";
import UserListingWithPagination from "../../../Components/search-common-components/UserListingWithPagination";
import SearchedGame from "../../../Components/search-common-components/SearchedGame";
import { toast } from "react-toastify";
import { rankingAPI } from "../../../services/eventsAPI";
import { GameData } from "../../../utility/types/gameShowTypes";
import { ShowLoader } from "../../../common/ShowLoader";
import NoDataFound from "../../../Components/NoDataFound";
import Genre from "../../../Components/Genre";
import PlayersViewScroll from "../../../Components/PlayersViewScroll";
import { set } from "date-fns";
import GameProfileSkeleton from "../../../Components/skeleton-components/GameProfileSkeleton";
import UserListingSkeleton from "../../../Components/skeleton-components/UserListingSkeleton";
import RankingSkeleton from "../../../Components/skeleton-components/RankingSkeleton";
import Header from "./Common/Header";
import { getUserProfile } from "../../../services/authAPI";
import Cards from "../../../Components/Cards";
import { ScreenBGGradientView } from "../../../common/CommonView";

const SearchGameWebScreen = ({ route }) => {
  const routeData = route.params;
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [userData, setUserData] = useState(null);
  const [popularData, setPopularData] = useState([]);
  const [upComingData, setUpComingData] = useState([]);
  const [upComingDataEmpty, setUpComingDataEmpty] = useState(false);
  const [isGetTicket, setIsGetTicket] = useState(false);
  const [popularIndex, setPopularIndex] = useState(0);
  const [upcomingIndex, setUpcomingIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMyEvents, setIsMyEvents] = useState(false);
  const [showEventTypeModal, setShowEventTypeModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [gameData, setGameData] = useState<GameData | null>(null);
  const [isUserDataEmpty, setIsUserDataEmpty] = useState(false);
  const [popularDataEmpty, setPopularDataEmpty] = useState(false);
  const [isRatingDataEmpty, setIsRatingDataEmpty] = useState(false);
  const [isGameDataAvailable, setIsGameDataAvailable] = useState(false);
  const [userProfileData, setUserProfileData] = useState(null);
  async function getLoginUserData() {
    const data = await getLoginData();
    if (data != null) {
      setUserData(data);
      userProfileAPI(data.AccessToken);
    }
  }
  const userProfileAPI = async (AccessToken?: string) => {
    try {
      setShowLoader(true);
      const data = await getUserProfile(AccessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200) {
        setUserProfileData(responseBody);
        await getRanking(AccessToken);
      } else if (data.statusCode == 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      console.log("Authorization failed: " + error.message);
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };
  async function getRanking(accessToken) {
    setShowLoader(true);
    try {
      const response = await rankingAPI(routeData.game, accessToken);
      setGameData(response);
      setPopularData(response.popularEvents);
      setUpComingData(response.upcomingEvents);
      setIsUserDataEmpty(!response?.users || response?.users?.length === 0);
      response.popularEvents.length === 0
        ? setPopularDataEmpty(true)
        : setPopularDataEmpty(false);
      response.upcomingEvents.length === 0
        ? setUpComingDataEmpty(true)
        : setUpComingDataEmpty(false);

      setIsRatingDataEmpty(
        !response?.rankingResult || response?.rankingResult?.length === 0
      );
      setIsGameDataAvailable(!!(response?.gameName && response?.image));
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  }
  useEffect(() => {
    getLoginUserData();
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <ScreenBGGradientView />
      {/* {(deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS) && (
        <MobileDeviceNavigationHeader
          createEventTapped={() => {
            setIsMyEvents(true);
          }}
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen
                // { txtSearch: searchEvent });
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen
                // { txtSearch: searchEvent });
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                // { txtSearch: searchEvent });
          }}
        />
      )} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        showsVerticalScrollIndicator={false}
      >
        <View style={[styles.container, {}]}>
          <CommonButton
            title="Back"
            onTap={() => {
              navigation.dispatch(StackActions.pop());
            }}
            buttonStyle={styles.btnStyle}
            textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
          />
          {deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.XS ? null : (
            <Separator
              color={AppColors.appViolentColor_6D08C3}
              height={2}
              marginTop={25}
              marginBottom={0}
              marginHorizontal={0}
            />
          )}
          <View
            style={{
              flexDirection:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "column"
                  : "row",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "100%"
                    : deviceSize === DEVICE_SIZES.MD ||
                      deviceSize === DEVICE_SIZES.LG
                    ? "auto"
                    : "16%",
                marginVertical: 25,
              }}
            >
              {showLoader ? (
                <GameProfileSkeleton />
              ) : !isGameDataAvailable ? (
                !showLoader && <NoDataFound marginTop={20} />
              ) : (
                <SearchedGame gameData={gameData} />
              )}
            </View>
            {deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.XS ? null : (
              <Separator
                color={AppColors.appViolentColor_6D08C3}
                height={"100%"}
                marginTop={0}
                marginBottom={0}
                marginHorizontal={0}
                width="2"
              />
            )}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "100%"
                    : deviceSize === DEVICE_SIZES.MD ||
                      deviceSize === DEVICE_SIZES.LG
                    ? "auto"
                    : "40%",
                marginVertical:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? 0
                    : 25,
                borderColor: AppColors.appViolentColor_6D08C3,
              }}
            >
              <View
                style={{
                  marginLeft:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : "2.5%",
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_16,
                    { color: AppColors.white, marginBottom: 10 },
                  ]}
                >
                  Players
                </Text>
                {isUserDataEmpty ? (
                  !showLoader && <NoDataFound marginTop={20} />
                ) : showLoader ? (
                  <UserListingSkeleton size={3} />
                ) : deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ? (
                  <PlayersViewScroll
                    userData={userData}
                    arrPopularGeners={gameData?.users}
                  />
                ) : (
                  <UserListingWithPagination
                    UserDataEmpty={!gameData || gameData?.users?.length === 0}
                    userResult={gameData?.users}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    userData={userData}
                    showLoader={showLoader}
                  />
                )}
              </View>
            </View>
            {deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.XS ? null : (
              <Separator
                color={AppColors.appViolentColor_6D08C3}
                height={"100%"}
                marginTop={0}
                marginBottom={0}
                marginHorizontal={0}
                width="2"
              />
            )}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "100%"
                    : deviceSize === DEVICE_SIZES.MD ||
                      deviceSize === DEVICE_SIZES.LG
                    ? "auto"
                    : "35%",
                marginVertical: 25,
                marginHorizontal:
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : "1%",
              }}
            >
              {showLoader ? (
                <RankingSkeleton />
              ) : (
                <GiftTable
                  isRatingDataEmpty={isRatingDataEmpty}
                  styles={styles}
                  showLoader={showLoader}
                  ratingResult={gameData?.rankingResult}
                  ratingDataEmpty={
                    !gameData || gameData?.rankingResult?.length === 0
                  }
                />
              )}
            </View>
          </View>
          {deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.XS ? null : (
            <Separator
              color={AppColors.appViolentColor_6D08C3}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          )}
          <View
            style={{
              marginTop:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : 25,
              paddingLeft: "2.5%",
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_16,
                {
                  color: AppColors.white,
                  marginTop: 10,
                },
              ]}
            >
              Challenges
            </Text>
            <ScrollView
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              {/* Popular Events  */}
              <Cards
                userData={userData}
                heading="Popular Events"
                CardData={popularData}
                CardDataEmpty={popularDataEmpty}
                // setIsGetTicket={setIsGetTicket}
                accessToken={userData?.AcessToken}
                showLoader={showLoader}
                popularIndex={popularIndex}
                setPopularIndex={setPopularIndex}
                userProfileData={userProfileData}
              />

              {/* Separater */}
              <Separator
                color={AppColors.appGrayColor_1C1C1C}
                height={2}
                marginTop={0}
                marginBottom={0}
                marginHorizontal={0}
                width="100%"
              />

              {/* Upcoming */}
              <Cards
                userData={userData}
                heading="Upcoming"
                CardData={upComingData}
                CardDataEmpty={upComingDataEmpty}
                // setIsGetTicket={setIsGetTicket}
                accessToken={userData?.AcessToken}
                showLoader={showLoader}
                popularIndex={upcomingIndex}
                setPopularIndex={setUpcomingIndex}
                userProfileData={userProfileData}
              />
            </ScrollView>
          </View>
        </View>
      </ScrollView>
      {/* {<ShowLoader showIndicater={showLoader} />} */}

      {showEventTypeModal && (
        <EventTypeScreen
          showModal={showEventTypeModal}
          setShowModal={setShowEventTypeModal}
        />
      )}
      {isMyEvents && (
        <CreateEventModal
          showModal={isMyEvents}
          setShowModal={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
        />
      )}
    </View>
  );
};

export default SearchGameWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      // paddingHorizontal: "3.5%",

      paddingRight: "2.5%",
      paddingTop: "2.5%",
    },
    btnStyle: {
      paddingVertical: 0,
      paddingHorizontal: 30,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 30,
      borderRadius: 13,
      alignSelf: "flex-end",
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
